export const GET_PRICING_PROCESSES_QUERY = `
  query GetPricingProcesses($where: pricing_process_bool_exp) {
    pricing_process(where: $where, order_by: { created_at: desc }) {
      id
      name
      description
      company_id
      status
      created_at
      company {
        id
        name
      }
    }
  }
`;

export const GET_PRICING_PROCESS_BY_ID_QUERY = `
  query GetPricingProcessById($id: Int!) {
    pricing_process_by_pk(id: $id) {
      id
      name
      description
      company_id
      status
      created_at
      company {
        id
        name
      }
    }
  }
`;
